module.exports = __webpack_public_path__ + "img/l_s3.07ce312d.png";